import { memo, useCallback } from 'react';

import { useIntl } from 'react-intl';
import { useDispatch } from 'react-redux';

import { HandleDismissedType } from 'src/redux/flags/types';
import { refreshCodeReviewData } from 'src/redux/pull-request/actions';
import { messages } from 'src/sections/repository/sections/pull-request/pull-request.i18n';

import { BasePullRequestUpdatedFlag } from './base-pull-request-updated-flag';

export const SOURCE_BRANCH_UPDATE_FLAG_ID = 'source-branch-updated';

type SourceBranchUpdateLinks = {
  diff: { href: string };
  diffstat: { href: string };
};

type Props = {
  id: typeof SOURCE_BRANCH_UPDATE_FLAG_ID;
  props?: {
    links: SourceBranchUpdateLinks;
  };
} & HandleDismissedType;

export const SourceBranchUpdatedFlag = memo((props: Props) => {
  const { id, handleDismissed, ...flagProps } = props;
  const links = flagProps.props?.links;
  const intl = useIntl();
  const dispatch = useDispatch();

  const handleRefresh = useCallback(() => {
    if (links) {
      dispatch(
        refreshCodeReviewData({
          links,
          needsComments: false,
          needsDiff: true,
          needsPullRequest: true,
          needsTasks: false,
        })
      );
    }
  }, [dispatch, links]);

  const formattedTitle = intl.formatMessage(messages.anchorMovedTitle);
  const formattedDescription = intl.formatMessage(
    messages.anchorMovedDescription
  );

  return (
    <BasePullRequestUpdatedFlag
      id={id}
      title={formattedTitle}
      description={formattedDescription}
      onRefresh={handleRefresh}
      handleDismissed={handleDismissed}
      {...flagProps}
    />
  );
});
